(() => {
  const initializeGallery = (gallery) => {
    if (gallery.dataset.galleryInitialized === 'true') return

    const section = gallery.closest('.shopify-section') || gallery.parentElement
    const galleryItems = Array.from(gallery.querySelectorAll('.gallery-item'))
    const modal = section?.querySelector('[data-gallery-modal]')
    const modalImage = modal?.querySelector('[data-gallery-modal-image]')
    const closeButton = modal?.querySelector('[data-gallery-modal-close]')
    let activeTrigger = null
    let previousBodyOverflow = ''

    gallery.dataset.galleryInitialized = 'true'

    const getAspectRatio = (image) => (image.naturalHeight ? image.naturalWidth / image.naturalHeight : 1)

    const closeModal = () => {
      if (!modal || modal.hidden) return

      modal.hidden = true
      if (modalImage) {
        modalImage.removeAttribute('src')
        modalImage.alt = ''
      }
      document.body.style.overflow = previousBodyOverflow

      if (activeTrigger) {
        activeTrigger.setAttribute('aria-expanded', 'false')
        activeTrigger.focus()
      }
      activeTrigger = null
    }

    const openModal = (trigger) => {
      if (!modal || !modalImage || !closeButton) return

      const image = trigger.querySelector('.gallery-image')
      activeTrigger = trigger
      previousBodyOverflow = document.body.style.overflow
      modalImage.src = trigger.dataset.galleryFullImage || image?.currentSrc || image?.src || ''
      modalImage.alt = trigger.dataset.galleryImageAlt || image?.alt || ''
      modal.hidden = false
      trigger.setAttribute('aria-expanded', 'true')
      document.body.style.overflow = 'hidden'
      closeButton.focus()
    }

    gallery.querySelectorAll('[data-gallery-lightbox]').forEach((trigger) => {
      trigger.addEventListener('click', () => openModal(trigger))
    })

    if (modal && closeButton) {
      closeButton.addEventListener('click', closeModal)

      modal.addEventListener('click', (event) => {
        if (event.target === modal) closeModal()
      })

      modal.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeModal()

        if (event.key === 'Tab') {
          event.preventDefault()
          closeButton.focus()
        }
      })
    }

    Promise.all(
      galleryItems.map((item) => {
        const image = item.querySelector('.gallery-image')
        if (!image) return Promise.resolve(null)

        return new Promise((resolve) => {
          if (image.complete) {
            resolve({ item, aspectRatio: getAspectRatio(image) })
          } else {
            image.addEventListener('load', () => resolve({ item, aspectRatio: getAspectRatio(image) }), { once: true })
            image.addEventListener('error', () => resolve({ item, aspectRatio: 1 }), { once: true })
          }
        })
      })
    ).then((itemsWithAspectRatios) => {
      itemsWithAspectRatios
        .filter((entry) => entry !== null)
        .sort((a, b) => a.aspectRatio - b.aspectRatio)
        .forEach(({ item }) => gallery.appendChild(item))
    })
  }

  const initializeGalleries = (root = document) => {
    if (root.matches?.('[data-dynamic-gallery]')) initializeGallery(root)
    root.querySelectorAll?.('[data-dynamic-gallery]').forEach(initializeGallery)
  }

  if (window.ByBlackshearDynamicGallery) {
    window.ByBlackshearDynamicGallery.initialize(document)
    return
  }

  window.ByBlackshearDynamicGallery = { initialize: initializeGalleries }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeGalleries(document), { once: true })
  } else {
    initializeGalleries(document)
  }

  document.addEventListener('shopify:section:load', (event) => initializeGalleries(event.target))
})()
